/**
 * @author mi
 * @date 2019/4/19
 * @project xingzhiyuan_2019
 */

import { isEmpty } from './is-empty'

let class2type = {}, toString = Object.prototype.toString;
(function () {
  var typeArr = 'Boolean,Number,String,Function,Array,Date,RegExp,Object'.split(',')
  for (var i = 0; i < typeArr.length; i++) {
    var name = typeArr[i]
    class2type['[object ' + name + ']'] = name.toLowerCase()
  }
})()

/**
 * 判断参数类型
 * @param obj {any}
 * @param type, {string} 类型：string, number
 * @returns {string}
 */
export function isType (obj, type) {
  return (obj == null
    ? String(obj)
    : class2type[toString.call(obj)] || 'object') === type
}

/**
 * 判断参数是否为布尔类型
 * @param obj
 * @returns {boolean}
 */
export function isBoolean (obj) {
  return isEmpty(obj) ? false : isType(obj, 'boolean')
}

/**
 * 判断参数是否为数字类型
 * @param obj
 * @returns {boolean}
 */
export function isNumeric (obj) {
  return isEmpty(obj) ? false : (isType(obj, 'number') || isType(obj, 'string')) && !isNaN(obj - parseFloat(obj))
}

export function isString (obj) {
  return isEmpty(obj) ? false : isType(obj, 'string')
}

export function isFunction (obj) {
  return isEmpty(obj) ? false : isType(obj, 'function')
}

export function isArray (obj) {
  return isEmpty(obj) ? false : isType(obj, 'array')
}

export function isDate (obj) {
  return isEmpty(obj) ? false : isType(obj, 'date')
}

export function isRegExp (obj) {
  return isEmpty(obj) ? false : isType(obj, 'regexp')
}

export function isObject (obj) {
  return isEmpty(obj) ? false : isType(obj, 'object')
}
